export const NAVIGATION_STORAGE_KEYS = Object.freeze({
    OPEN_KEYS: "flymeta.sidebar.openGroups",
    LAST_PATH: "flyMeta_last_path",
    SIDEBAR_OPEN: "flymeta.sidebar.open",
    SCROLL_TOP: "flymeta.sidebar.scrollTop",
});

function readStorage(key) {
    try {
        return localStorage.getItem(key);
    } catch {
        return null;
    }
}

function writeStorage(key, value) {
    try {
        localStorage.setItem(key, value);
    } catch {
        // 忽略 localStorage 异常，避免影响主流程
    }
}

export function readStoredOpenKeys(defaultKeys = []) {
    const rawValue = readStorage(NAVIGATION_STORAGE_KEYS.OPEN_KEYS);

    if (!rawValue) {
        return defaultKeys;
    }

    try {
        const parsed = JSON.parse(rawValue);
        return Array.isArray(parsed) ? parsed : [];
    } catch {
        return [];
    }
}

export function writeStoredOpenKeys(keys) {
    writeStorage(NAVIGATION_STORAGE_KEYS.OPEN_KEYS, JSON.stringify(Array.isArray(keys) ? keys : []));
}

export function readStoredSidebarOpen(defaultOpen = true) {
    const rawValue = readStorage(NAVIGATION_STORAGE_KEYS.SIDEBAR_OPEN);

    if (rawValue === "true") {
        return true;
    }

    if (rawValue === "false") {
        return false;
    }

    return defaultOpen;
}

export function writeStoredSidebarOpen(open) {
    writeStorage(NAVIGATION_STORAGE_KEYS.SIDEBAR_OPEN, String(Boolean(open)));
}

export function readStoredLastPath() {
    const lastPath = readStorage(NAVIGATION_STORAGE_KEYS.LAST_PATH);
    return typeof lastPath === "string" && lastPath ? lastPath : null;
}

export function writeStoredLastPath(pathname) {
    if (!pathname || pathname === "/") {
        return;
    }

    writeStorage(NAVIGATION_STORAGE_KEYS.LAST_PATH, pathname);
}
